<!--
 * @Author: zhaowh zhaowh@example.com
 * @Date: 2023-09-19 14:58:01
 * @LastEditors: zhaowh zhaowh@example.com
 * @LastEditTime: 2023-10-13 10:21:16
-->
<template>
  <el-main>
    <div class="top-wrap">
      <Bread></Bread>
    </div>
    <div class="main">
      <p class="detail-tit">产品详情</p>
      <p class="tit-bor-left" style="margin-top: 16px">申请信息</p>
      <el-table :data="applyInfo" style="width: 100%; margin-top: 10px">
        <el-table-column
          prop="createTime"
          label="申请时间"
          min-width="15%"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="userName"
          label="申请人"
          min-width="15%"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="mobile"
          label="手机号"
          min-width="15%"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="region"
          label="所属地区"
          min-width="10%"
          align="center"
        >
          <template slot-scope="{ row }">
            {{ row.provinceName }}{{ row.cityName }}{{ row.areaName }}
          </template>
        </el-table-column>
      </el-table>
      <div class="title">
        {{ companyName }}{{ businessAddress ? `-${businessAddress}` : '' }}
      </div>
      <p class="tit-bor-left">{{ productName }}</p>
      <table class="table-static">
        <tr>
          <th>适用地区</th>
          <td colspan="3">
            <span v-for="(item, index) in addressList" :key="index">
              {{ item.provinceName }}{{ item.cityName
              }}{{ item.areaName }}，</span
            >
          </td>
        </tr>
        <tr>
          <th>适用对象</th>
          <td>
            <span v-for="(item, index) in applyObjectList" :key="index">
              {{ item }}，</span
            >
          </td>
          <th>保险期限</th>
          <td>
            {{
              detailList.insurePeriod ? `${detailList.insurePeriod} %` : ' - '
            }}
          </td>
        </tr>
        <tr>
          <th>保险金融</th>
          <td>
            {{
              detailList.insureLimit ? `${detailList.insureLimit} 万` : ' - '
            }}
          </td>
          <th>政府贴息</th>
          <td>
            {{ detailList.govPayAmount ? `${detailList.govPayAmount}` : '无' }}
          </td>
        </tr>
        <tr>
          <th>保费</th>
          <td colspan="3">
            {{ detailList.insureCost ? `${detailList.insureCost} 起` : ' - ' }}
          </td>
        </tr>
        <tr>
          <th>产品介绍</th>
          <td colspan="3">
            {{
              detailList.productIntroduce ? detailList.productIntroduce : ' - '
            }}
          </td>
        </tr>
        <tr>
          <th>保障范围</th>
          <td colspan="3">
            {{ detailList.ensureScope ? detailList.ensureScope : ' - ' }}
          </td>
        </tr>
        <tr>
          <th>保险责任</th>
          <td colspan="3">
            {{ detailList.insureDuty ? detailList.insureDuty : ' - ' }}
          </td>
        </tr>
        <tr>
          <th>投保要求</th>
          <td colspan="3">
            {{ detailList.insureRequire ? detailList.insureRequire : ' - ' }}
          </td>
        </tr>
        <tr>
          <th>理赔流程</th>
          <td colspan="3">
            {{ detailList.claimFlow ? detailList.claimFlow : ' - ' }}
          </td>
        </tr>
        <tr>
          <th>其他</th>
          <td colspan="3">{{ detailList.other ? detailList.other : ' - ' }}</td>
        </tr>
      </table>
    </div>
  </el-main>
</template>
<script>
export default {
  name: 'InsureViewDetail',
  data() {
    return {
      applyInfo: [], // 申请信息
      detailList: {}, // 详情列表
      businessAddress: '', // 业务网点
      applyObjectList: [], // 适用对象
      addressList: [], // 地区
      companyName: '',
      productName: '',
    }
  },
  created() {
    this.businessAddress = this.$route.query.businessAddress
    this.companyName = this.$route.query.companyName
    this.productName = this.$route.query.productName
    this.getLoanIntentionSelectOneList()
  },
  methods: {
    getLoanIntentionSelectOneList() {
      let params = {
        id: this.$route.query.productId,
      }
      this.$http.insure.getInsureProductDetail(params).then((res) => {
        this.detailList = res.data
        let _detailList = this.detailList
        let _arr = []
        _detailList.applyObject.forEach((item) => {
          if (item == 1) {
            item = '种植户'
          } else if (item == 2) {
            item = '农户'
          } else if (item == 3) {
            item = '服务组织'
          } else if (item == 4) {
            item = '村集体'
          }
          _arr.push(item)
        })
        this.$set(this, 'addressList', _detailList.areaList)
        this.$set(this, 'applyObjectList', _arr)
        this.getInsureIntentionDetail()
      })
    },
    // 申请信息接口
    getInsureIntentionDetail() {
      let params = {
        id: this.$route.query.id,
      }
      this.$http.insure.getInsureIntentionDetail(params).then((res) => {
        this.$set(this, 'applyInfo', [res.data])
      })
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@/styles/common.scss';
.main {
  .detail-tit {
    font-size: 20px;
    font-weight: bold;
    color: #018388;
    padding-bottom: 15px;
    border-bottom: 1px solid #e9ebee;
  }
  .title {
    font-size: 18px;
    color: #212121;
    font-weight: bold;
    margin: 18px 0;
  }
  .tit-bor-left {
    margin-bottom: 11px;
  }
}
</style>
